<div *ngIf="cards.length > 1; else singleCard" class="detail-parent-card">
  <span class="detail-card-title mb-2" i18n>Recurring Payments</span>
  <app-vb-payment-change-recurring-payment-instruction-card
    *ngFor="let card of cards; trackBy: trackByIndex"
    [card]="card"
    [showStatusPill]="true" />
</div>
<ng-template #singleCard>
  <app-vb-payment-change-recurring-payment-instruction-card
    *ngIf="cards.length === 1"
    [card]="cards[0]"
    [showStatusPill]="false" />
</ng-template>
